import React, { ReactElement } from 'react';
import { useParams } from 'react-router';
import { ConfirmModal } from 'slovlex-idsk-react-components';
import { Button, LoaderButton } from 'idsk-react-components';
import { useSuccessMessageContext } from '../../../../../context/SuccessMessageContext';
import { ClientResponse } from '../../../../../model/ClientResponse';
import { ClientStatus } from '../../../../../model/ClientStatus';
import { ObalMaterialuNrSr } from '../../../../../model/sprievodnyDokument/obalMaterialu/ObalMaterialuNrSr';

interface Props {
  setObalMaterialu: (obalData: ObalMaterialuNrSr) => void;
  fillSystemDataClient(...args): Promise<ClientResponse<ObalMaterialuNrSr>>;
  fillSystemData: ObalMaterialuNrSr;
  fillSystemDataStatus: ClientStatus;
}

const ObalMaterialuNrSrFillSystemDataButton = ({
  setObalMaterialu,
  fillSystemDataStatus,
  fillSystemDataClient,
  fillSystemData,
}: Props): ReactElement => {
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();

  const {
    clearMessages,
    displaySuccess,
  } = useSuccessMessageContext();

  const onFillDataClick = async (): Promise<void> => {
    await fillSystemDataClient(type, year, index);
    setObalMaterialu(fillSystemData);
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  return (
    <ConfirmModal
      question="Naozaj si prajete automaticky vyplniť formulár?"
      description="Po vykonaní tejto funkcionality budú prepísané všetky údaje v tomto formulári."
      cancelButtonText="Nie"
      confirmButton={
        (
          <Button
            buttonStyle="action"
            size="large"
          >
            Áno
          </Button>
        )
      }
      openButton={(
        <LoaderButton
          className="fill-obal-data-vseobecny-button"
          buttonStyle="third"
          size="large"
          onClick={clearMessages}
          loading={fillSystemDataStatus.loading}
          disableOutsideClickWhileLoading
        >
          Vyplniť údajmi zo systému
        </LoaderButton>
      )}
      doAfterConfirm={onFillDataClick}
    />
  );
};

export default ObalMaterialuNrSrFillSystemDataButton;
